import { createUseStyles } from 'react-jss'

import { DropdownStyleProps } from './dropdown.types'

export const useStyle = createUseStyles({
  container: {
    width: ({ fixed }: DropdownStyleProps) => (fixed ? 200 : 'auto')
  }
})
